export const FLOOR_HEIGHT = 3;
